import {createReducer, statusStateEnhancer} from 're-reducer'
import updateHelper from 'immutability-helper'

import {prefix, initialState} from './selectors'

const reducer = createReducer({
  prefix,
  initialState
})

const {
  register
} = reducer

export const add = register(
  'ADD',
  statusStateEnhancer((state, action) => {
    const {
      payload: shop
    } = action

    const index = state.indexOf(shop)

    if (index > -1) {
      return state
    }

    const nextState = updateHelper(state, {
      $unshift: [shop]
    })

    return nextState
  })
)

export const remove = register(
  'REMOVE',
  statusStateEnhancer((state, action) => {
    const {
      payload: shop
    } = action

    const index = state.findIndex((x) => String(x) === String(shop))

    if (index < 0) {
      return state
    }

    const nextState = updateHelper(state, {
      $splice: [
        [index, 1]
      ]
    })

    return nextState
  })
)

export default reducer



// WEBPACK FOOTER //
// ./src/services/store/shops/index.js